import * as React from 'react';
export const chimeSvg = React.forwardRef(function chimeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1EC677',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.458 27c3.733 0 6.378-1.4 7.952-2.573v-5.098c-2.32 1.817-5.047 2.863-7.465 2.863-3.863 0-6.573-2.638-6.573-6.433 0-3.603 2.467-6.111 5.988-6.111 1.153 0 2.143.29 3.198.579 1.087.305 2.223.643 3.57.643a8.39 8.39 0 0 0 1.266-.097V5.917c-.357.032-.698.064-1.055.064-1.217 0-2.32-.225-3.473-.466C18.649 5.257 17.399 5 15.922 5c-2.937 0-5.664 1.03-7.66 2.927C6.136 9.937 5 12.735 5 16c0 6.481 4.706 11 11.458 11Z',
      fill: '#fff',
    }),
  );
});
chimeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chime = {
  category: 'brand',
  colorable: false,
  name: 'chime',
  svg: chimeSvg,
};
